<template>
  <v-layout :show-navigation="false">
    <div class="col ma-register">
      <div class="panel clearfix">
        <h1>Wachtwoord opvragen</h1>
        <forgot-password-form />
      </div>
    </div>
  </v-layout>
</template>

<script>
import VLayout from '../layouts/Default'
import ForgotPasswordForm from '../components/forms/ForgotPasswordForm'

export default {
  name: 'ForgotPasswordPage',
  components: {
    VLayout,
    ForgotPasswordForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ForgotPasswordPage.vue